import { Avatar, Badge, Box, Button, Flex, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, SimpleGrid, Text, useToast, VStack } from '@chakra-ui/react';
import { FiGift, FiStar } from 'react-icons/fi';

export const MemberDetailsModal = ({ isOpen, onClose, member, availableVouchers }) => {
    const toast = useToast();

    if (!member) return null;

    const handleRedeem = (voucher) => {
        if (member.points < voucher.pointsRequired) {
            toast({
                title: 'Not enough points',
                description: `${member.name} needs ${voucher.pointsRequired - member.points} more points for this voucher.`,
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top',
            });
            return;
        }

        toast({
            title: 'Voucher Redeemed!',
            description: `Successfully redeemed ${voucher.title} for ${member.name}.`,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top',
        });
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size='xl' isCentered scrollBehavior='inside'>
            <ModalOverlay backdropFilter='blur(4px)' />
            <ModalContent borderRadius='2xl' overflow='hidden'>
                <Box bg='linear-gradient(135deg, #F43F5E 0%, #FB7185 100%)' pt={8} pb={6} px={6} color='white' position='relative'>
                    <ModalCloseButton color='white' />
                    <Flex align='center' gap={5}>
                        <Avatar size='xl' name={member.name} src={member.avatar} border='4px solid white' />
                        <VStack align='start' spacing={1}>
                            <Text fontSize='2xl' fontWeight='black' letterSpacing='tight'>
                                {member.name}
                            </Text>
                            <Flex gap={2}>
                                <Badge colorScheme={member.role === 'Parent' ? 'blue' : 'green'} variant='solid' borderRadius='full' px={2}>
                                    {member.role}
                                </Badge>
                                {member.isMember && (
                                    <Badge colorScheme='red' variant='solid' borderRadius='full' px={2} display='flex' alignItems='center' gap={1}>
                                        <Icon as={FiStar} /> Member
                                    </Badge>
                                )}
                            </Flex>
                            <Text mt={2} fontWeight='bold' fontSize='lg' display='flex' alignItems='center' gap={2}>
                                <Icon as={FiGift} />
                                {member.points.toLocaleString('id-ID')} Points
                            </Text>
                        </VStack>
                    </Flex>
                </Box>

                <ModalBody py={6} px={6} bg='gray.50'>
                    <Text fontWeight='bold' color='gray.800' mb={4}>
                        Available Vouchers
                    </Text>
                    <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
                        {availableVouchers.map((voucher) => {
                            const canAfford = member.points >= voucher.pointsRequired;

                            return (
                                <Flex key={voucher.id} direction='column' bg='white' p={4} borderRadius='xl' border='1px' borderColor='gray.100' boxShadow='sm' opacity={canAfford ? 1 : 0.6}>
                                    <Flex justify='space-between' align='start' mb={2}>
                                        <Text fontSize='3xl'>{voucher.image}</Text>
                                        <Badge colorScheme={canAfford ? 'green' : 'gray'} borderRadius='full'>
                                            {voucher.pointsRequired} pts
                                        </Badge>
                                    </Flex>
                                    <Text fontWeight='bold' color='gray.800' mb={1}>
                                        {voucher.title}
                                    </Text>
                                    <Text fontSize='xs' color='gray.500' mb={4} flex={1}>
                                        {voucher.description}
                                    </Text>

                                    <Button size='sm' colorScheme='red' variant={canAfford ? 'solid' : 'outline'} w='full' onClick={() => handleRedeem(voucher)} isDisabled={!canAfford} borderRadius='full'>
                                        {canAfford ? 'Redeem Now' : 'Not Enough Points'}
                                    </Button>
                                </Flex>
                            );
                        })}
                    </SimpleGrid>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
